<div class="col-12">
    <div class="grid">
        <div class="col-12">
            <h3 *ngIf="loanType == 0" class="text-center">Run Your Numbers</h3>
            <h4 *ngIf="loanType == 0" class="text-center">Which Loan Type Are You Looking For?</h4>
            <button *ngIf="loanType!=0" pButton label="Change Loan Type" icon="pi pi-angle-left" (click)="loanType=0"></button>
        </div>
        <div class="col-12 sm:col-12 md:col-4" *ngIf="loanType == 0">
            <div class="card shadow-4 hover:shadow-8" (click)="loanType=1" style="cursor:pointer;border:2px solid #e72a2b">
                <h2 class="text-center">Rental Refinance</h2>
            </div>
        </div>
        <div class="col-12 sm:col-12 md:col-4" *ngIf="loanType == 0">
            <div class="card shadow-4 hover:shadow-8" (click)="loanType=2" style="cursor:pointer;border:2px solid #e72a2b">
                <h2 class="text-center">Rental Purchase</h2>
            </div>
        </div>
        <div class="col-12 sm:col-12 md:col-4" *ngIf="loanType == 0">
            <div class="card shadow-4 hover:shadow-8" (click)="loanType=3" style="cursor:pointer;border:2px solid #e72a2b">
                <h2 class="text-center">Rehab Loan</h2>
            </div>
        </div>
    
        <div class="col-12">
            <app-rental-refi-form *ngIf="loanType == 1"></app-rental-refi-form>
            <app-rental-purchase-form *ngIf="loanType == 2"></app-rental-purchase-form>
            <app-rehab-form *ngIf="loanType == 3"></app-rehab-form>
        </div>
    </div>
</div>
